__turbopack_context__.v({
  "fullwidth": "HTMLEmbed-module-scss-module__JVFuKW__fullwidth",
  "grayscale": "HTMLEmbed-module-scss-module__JVFuKW__grayscale",
  "wrapper": "HTMLEmbed-module-scss-module__JVFuKW__wrapper",
});
